import { render, staticRenderFns } from "./constraintPolygon.vue?vue&type=template&id=53692bc0&scoped=true"
import script from "./constraintPolygon.vue?vue&type=script&lang=js"
export * from "./constraintPolygon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53692bc0",
  null
  
)

export default component.exports